import React from 'react';

const SecurityCustomerLogo = () => {
    return (
        <section className="security_customers_logo_area" id="technologies">
            <div className="container">
                <div className="hosting_title analytices_title text-center">
                    <h2 className="wow fadeInUp"><span>Our Technologies. </span>Latest & Trending Tech Used.!</h2>
                    <p className="wow fadeInUp" data-wow-delay="0.3s">Leveraging technologies to drive a better user
                        experience. At GreenHubLK, we take pride in our work and enjoy the satisfaction of a job well
                        done.!</p>
                </div>
                <div className="security_inner">
                    <img className="p_absoulte security_leaf_left wow fadeInDown" data-wow-delay="0.8s"
                         src={require("../img/home-security/leaf_clients2.png")} alt=""/>
                    <img className="p_absoulte security_leaf_right wow fadeInDown" data-wow-delay="0.8s"
                         src={require("../img/home-security/leaf_clients1.png")} alt=""/>
                    <div className="row">
                        <div className="col-lg-3 col-sm-4 col-6">
                            <a className="analytices_logo wow fadeInUp"><img
                                src={require("../img/home-software/java.png")} alt=""/></a>
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                            <a className="analytices_logo wow fadeInUp" data-wow-delay="0.2s"><img
                                src={require("../img/home-software/python.png")} alt=""/></a>
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                            <a className="analytices_logo wow fadeInUp" data-wow-delay="0.4s"><img
                                src={require("../img/home-software/android.png")} alt=""/></a>
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                            <a className="analytices_logo wow fadeInUp" data-wow-delay="0.6s"><img
                                src={require("../img/home-software/mongodb.png")} alt=""/></a>
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                            <a className="analytices_logo wow fadeInUp"><img
                                src={require("../img/home-software/spring.png")} alt=""/></a>
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                            <a className="analytices_logo wow fadeInUp" data-wow-delay="0.2s"><img
                                src={require("../img/home-software/fastapi.png")} alt=""/></a>
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                            <a className="analytices_logo wow fadeInUp" data-wow-delay="0.4s"><img
                                src={require("../img/home-software/netlify.png")} alt=""/></a>
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                            <a className="analytices_logo wow fadeInUp" data-wow-delay="0.6s"><img
                                src={require("../img/home-software/photoshop.png")} alt=""/></a>
                        </div>
                        {/*IDEs*/}
                        <div className="col-lg-3 col-sm-4 col-6">
                            <a className="analytices_logo wow fadeInUp"><img
                                src={require("../img/home-software/android_studio.png")} alt=""/></a>
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                            <a className="analytices_logo wow fadeInUp" data-wow-delay="0.2s"><img
                                src={require("../img/home-software/intelij.png")} alt=""/></a>
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                            <a className="analytices_logo wow fadeInUp" data-wow-delay="0.4s"><img
                                src={require("../img/home-software/pycharm.png")} alt=""/></a>
                        </div>
                        <div className="col-lg-3 col-sm-4 col-6">
                            <a className="analytices_logo wow fadeInUp" data-wow-delay="0.6s">
                                <img src={require("../img/home-software/webstorm.png")} alt=""/></a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default SecurityCustomerLogo;
